import React from 'react';
import { Box, PrimaryButton, Flex, Text } from '@stashinvest/ui';
import { isNativeWebview } from 'stash/utils';
import useLogout from 'stash/hooks/useLogout';

function ErrorMessage() {
	const nativeWebview = isNativeWebview();
	const { logoutUser } = useLogout();

	return (
		<Flex
			flexDirection="column"
			minHeight="75vh"
			justifyContent="center"
			alignItems="center"
		>
			<Box p="m" align="center" maxWidth="32rem" width="100%">
				<Text.H2 size="1" align="center">
					<span role="img" aria-label="thinking face">
						🤔
					</span>
				</Text.H2>
				<Text.H3 mb="xxs">Whoops, something went wrong</Text.H3>
				<Text mb="l">
					{nativeWebview
						? 'Try logging out, closing the app and logging back in.'
						: 'Try reloading or clearing your browser’s history or cache and logging back in.'}
				</Text>
				{nativeWebview ? (
					<PrimaryButton
						type="button"
						mb="m"
						onClick={() => {
							logoutUser();
						}}
					>
						Logout
					</PrimaryButton>
				) : (
					<PrimaryButton
						type="button"
						mb="m"
						onClick={() => {
							window.location.reload();
						}}
					>
						Reload Stash
					</PrimaryButton>
				)}
			</Box>
		</Flex>
	);
}

export default ErrorMessage;
